import { useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconHome } from '@tabler/icons'
import { useRouter } from 'next/router'
import React from 'react'

import { Breadcrumbs } from '@/components/ui/navigation/Breadcrumbs'
import { Breadcrumb as BreadcrumbType, Site as SiteType } from '@/types'

interface Props {
  siteData?: SiteType
  children?: React.ReactNode
}

export default function BreadcrumbNav({ siteData }: Props) {
  // Hooks
  const theme = useMantineTheme()
  const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)
  const router = useRouter()

  // Constants
  const { creditCardUid, orderNumber } = router.query || {}
  const paths = router.asPath.split('/')
  const accountsPath = '/_sites/[site]/accounts'

  const breadcrumbsItems: BreadcrumbType[] = [
    {
      title: 'Minha Conta',
      href: '/accounts/',
      icon: <IconHome size={isXs ? 14 : 18} />,
      isActive: router?.pathname === accountsPath
    }
  ]
  if (paths.indexOf('addresses') >= 0) {
    breadcrumbsItems.push({
      title: 'Meus Endereços',
      href: '/accounts/addresses/',
      isActive: router?.pathname === `${accountsPath}/addresses`
    })
  }
  if (paths.indexOf('channels') >= 0) {
    breadcrumbsItems.push({
      title: 'Minhas Lojas',
      href: '/accounts/profiles/',
      isActive: router?.pathname === `${accountsPath}/profiles`
    })
  }
  if (paths.indexOf('credit-cards') >= 0) {
    breadcrumbsItems.push({
      title: 'Meus Cartões de Crédito',
      href: '/accounts/credit-cards/',
      isActive: router?.pathname === `${accountsPath}/credit-cards`
    })
    if (creditCardUid) {
      breadcrumbsItems.push({
        title: 'Cartão de Crédito',
        href: `/accounts/credit-cards/${creditCardUid}`,
        isActive: router?.pathname === `${accountsPath}/credit-cards/[creditCardUid]`
      })
    }
  }
  if (paths.indexOf('enrollments') >= 0) {
    breadcrumbsItems.push({
      title: 'Meus Alunos',
      href: '/accounts/enrollments/',
      isActive: router?.pathname === `${accountsPath}/enrollments`
    })
  }
  if (paths.indexOf('orders') >= 0) {
    breadcrumbsItems.push({
      title: 'Meus Pedidos',
      href: '/accounts/orders/',
      isActive: router?.pathname === `${accountsPath}/orders`
    })
    if (orderNumber) {
      breadcrumbsItems.push({
        title: 'Detalhes do Pedido',
        href: `/accounts/orders/${orderNumber}`,
        isActive: router?.pathname === `${accountsPath}/orders/[orderNumber]`
      })
    }
  }

  return <Breadcrumbs breadcrumbs={breadcrumbsItems.filter(item => Boolean(item.title))} />
}
